<template>
  <div>
    <div class="row p-1 d-flex justify-content-center text-center tipo-dec" v-if="tipoDec">
      <b>Declaración {{tipoDec?tipoDec:''}} / {{anio? anio:''}}</b>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        tipoDec: '',
        anio: ''
      }
    },
    created() {
      this.tipoDec = this.getKey('tipo_dec');
      this.anio = this.getKey('periodo');
      // this.anio = this.getKey('periodo');
    },
  }

</script>
<style>
  .tipo-dec {
    background: #0078e1;
    color: #FFF;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TipoDec.vue